import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { trackEvent, utmParams } from "@/lib/analytics";
import { clarityEvent } from "@/lib/clarity";
import { CalendarClock } from "lucide-react";
import api from "@/lib/api";
import { getHostClass } from "@/lib/host";

// DEMO-SCHEDULING-1 · "Schedule a Demo" is a B2B merchant-acquisition CTA. It renders only on the
// brand site (main host) and only on these merchant marketing paths — never on shopper surfaces.
const MERCHANT_PATHS = ["/", "/pricing", "/why-cyannect", "/about", "/demo", "/api-docs", "/developers",
  "/docs/web-sdk", "/faq", "/blog", "/login", "/register"];

let configPromise = null;
export function loadDemoConfig() {
  if (!configPromise) configPromise = api.get("/demo/config").then((r) => r.data).catch(() => ({ enabled: false }));
  return configPromise;
}

export function isMerchantMarketingPath(pathname) {
  if (getHostClass() !== "main") return false;
  return MERCHANT_PATHS.some((p) => pathname === p || (p === "/blog" && pathname.startsWith("/blog/")));
}

export function useDemoCtaVisible() {
  const { pathname } = useLocation();
  const [enabled, setEnabled] = useState(false);
  useEffect(() => { loadDemoConfig().then((c) => setEnabled(!!c.enabled)); }, []);
  return enabled && isMerchantMarketingPath(pathname);
}

export function DemoCta({ testid, className = "", children = "Schedule a Demo", icon = false }) {
  const visible = useDemoCtaVisible();
  if (!visible) return null;
  return (
    <Link to="/demo" data-testid={testid} className={className} onClick={() => { trackEvent("request_demo_click", { cta: testid || "demo_cta", ...utmParams() }); clarityEvent("request_demo_clicked"); }}>
      {icon && <CalendarClock className="w-4 h-4" />} {children}
    </Link>
  );
}
